import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-active-call-icon',
  templateUrl: './communication-active-call.component.html'
})
export class CommunicationActiveCallComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
